<template>
<div>
  <xh-dialog
    title="修改题目名称"
    :visible.sync="dialogVisible"
    width="460px"
    class='dialog'
    appendToBody
    center
  >
    <el-input
      placeholder="请输入scratch标题内容"
      v-model="input"
      clearable>
    </el-input>
    <div
      class="btns-wrapper"
    >
      <Button
        type="text"
        class="btn btn-cancel"
        @click="cancel"
      >取消</Button>
      <Button
        type="text"
        class="btn btn-confirm"
        @click="confirm"
      >确定</Button>
    </div>
  </xh-dialog>
</div>
</template>

<script>
import Button from '@/components/Button.vue';
import Vue from 'vue'
import { Input } from 'element-ui';
Vue.use(Input);

export default {
  name: 'modify-sa-title',

  components: {
    Button,
  },

  data() {
    return {
      dialogVisible: false,
      input: '',
    };
  },

  props: {
    currentExercise: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    currentExercise: {
      handler(newVal) {
        this.input = this.getTitle(newVal);
      },
      immediate: true,
    },
  },

  methods: {
    showQuit() {
      this.dialogVisible = true;
    },
    cancel() {
      const originTitle = this.getTitle(this.currentExercise);
      this.input = originTitle;
      this.dialogVisible = false;
    },
    confirm() {
      this.$emit('update:current-exercise', {
        ...this.currentExercise,
        practiceName: this.input,
      });
      window.frames[0].postMessage(JSON.stringify({
        type: 'XH_MODIFY_SA_TITLE',
        payload: this.input,
      }), '*');
      this.dialogVisible = false;
    },
    getTitle(obj) {
      const { category, practiceName } = obj;
      if (category === 2) return practiceName;
      return practiceName;
    },
  },
  beforeDestroy() {
    this.dialogVisible = false;
  },
};
</script>

<style scoped lang="less">
.dialog {
  z-index: 20;
}

.btns-wrapper {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: space-around;

  .btn {
    width:110px;
    height:40px;
    font-size: 16px;
    border-radius:20px;
  }
  .btn-cancel {
    color: #333;
    background:#FFF7E7;
    border:2px solid #FCEBCB;
  }
  .btn-confirm {
    color: #fff;
    background:#68953C;
    border:2px solid #4B7635;
  }
}

/deep/ .xh_dialog {
  min-height: 228px;

  .xh_dialog__header {
    padding-top: 25px;

    .xh_dialog__title {
      font-size:24px;
      font-weight:500;
      color:#333;
      line-height:33px;
      letter-spacing:1px;
    }
  }
  .xh_dialog__body {
    padding: 25px 60px;
  }
}

/deep/ .el-input__inner:focus {
  border-color: #C0C0C0;
}
</style>
